export const getCentrideskIntegration = (integrations) =>
  (integrations || []).find(
    (int) => int.channel === "centridesk" && int.active !== false && int.info?.use_custom_fields
  );

export const selectField = (field) => ({
  key_name: field.key_name,
  type: field.type,
  title: field.title,
  equivalences: [],
  options: field.type === "dropdown" ? [...(field.options || [])] : [],
});

const currentField = (mapping, fields) => (fields || []).find((field) => field.key_name === mapping?.key_name);

export const fieldOptions = (mapping, fields) => currentField(mapping, fields)?.options || [];

export const isMissingField = (mapping, fields) =>
  Boolean(mapping?.key_name && fields != null && !fields.some((field) => field.key_name === mapping.key_name));

export const optionsChanged = (mapping, fields) => {
  const field = mapping?.type === "dropdown" && fields != null ? currentField(mapping, fields) : null;
  if (!field) return false;
  const saved = mapping.options || [];
  const current = field.options || [];
  return saved.length !== current.length || saved.some((option, i) => option !== current[i]);
};

export const refreshOptions = (mapping, fields) => ({
  ...mapping,
  options: [...(currentField(mapping, fields)?.options || [])],
});

const withEquivalences = (mapping, equivalences) => ({ ...mapping, equivalences });

export const addEquivalence = (mapping) =>
  withEquivalences(mapping, [...(mapping.equivalences || []), { text: "", value: "" }]);

export const setEquivalenceText = (mapping, index, text) =>
  withEquivalences(mapping, mapping.equivalences.map((eq, i) => (i === index ? { ...eq, text } : eq)));

export const setEquivalenceValue = (mapping, index, value) =>
  withEquivalences(mapping, mapping.equivalences.map((eq, i) => (i === index ? { ...eq, value } : eq)));

export const deleteEquivalence = (mapping, index) =>
  withEquivalences(mapping, mapping.equivalences.filter((_, i) => i !== index));

export const getVariableDeskCentridesk = (variablesDesk, name) =>
  (variablesDesk || []).find((variable) => variable?.name === name)?.centridesk_ticket_field;

export const setVariableDeskCentridesk = (variablesDesk, name, mapping) => {
  const list = (variablesDesk || []).filter(Boolean);
  const exists = list.some((variable) => variable.name === name);

  const updated = list.map((variable) => {
    if (variable.name !== name) return variable;
    const { centridesk_ticket_field, ...rest } = variable;
    return mapping ? { ...rest, centridesk_ticket_field: mapping } : rest;
  });

  return exists || !mapping ? updated : [...updated, { name, centridesk_ticket_field: mapping }];
};
